export default __webpack_public_path__ + "static/media/Pcv1AssemblyH1.3ae21fd6.png";